const updateSponsoredProduct = (product, sponsoredProducts) => {
  if (!product.isSponsored) {
    return product;
  }

  const variantId = product.advertisement.variantId;
  const sponsoredProduct = sponsoredProducts.find(
    ({ ProductId }) => ProductId === variantId,
  );

  if (!sponsoredProduct) {
    return product;
  }

  return {
    ...product,
    advertisement: {
      ...product.advertisement,
      onLoadBeacon: sponsoredProduct.OnLoadBeacon,
      onViewBeacon: sponsoredProduct.OnViewBeacon,
      onClickBeacon: sponsoredProduct.OnClickBeacon,
      onBasketChangeBeacon: sponsoredProduct.OnBasketChangeBeacon,
      onWishlistBeacon: sponsoredProduct.OnWishlistBeacon,
    },
  };
};

export const clearOnViewBeaconReducer = (state) => {
  state.diagnostics.advertisementsAnalytics.placementBeacons.onViewBeacon =
    null;
};

export const clearOnLoadBeaconReducer = (state) => {
  state.diagnostics.advertisementsAnalytics.placementBeacons.onLoadBeacon =
    null;
};

export const refreshAdvertisementBeaconsReducer = (
  state,
  { sponsoredProducts, onLoadBeacon, onViewBeacon },
  { syncProductsEntity },
) => {
  state.products = sponsoredProducts
    ? state.products.map((product) =>
        updateSponsoredProduct(product, sponsoredProducts),
      )
    : state.products;

  syncProductsEntity(state);
  state.diagnostics = {
    ...state.diagnostics,
    advertisementsAnalytics: {
      placementBeacons: {
        onLoadBeacon,
        onViewBeacon,
      },
    },
  };
};
